import * as React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import {
  withTheme,
  CircularProgress,
  LinearProgress,
  Dialog,
  Button,
} from "@material-ui/core";
import { Favorite, ShoppingCart } from "@material-ui/icons";
import { getImageUrl } from "../../framework/getImageUrl";
import LazyLoad from "react-lazy-load";
import FFAppBar from "../sharedComponents/FFAppBar";
import s from "./dashboard.module.css";
import ItemView from "../ItemView";
import globalContext from "../../context/globalContext";
import asmLogo from "./applestreetmarket.png";
import OldShoppingCartDialog from "../OldShoppingCartDialog";

class Dashboard extends React.Component {
  static contextType = globalContext;
  constructor(props) {
    super(props);
    this.state = {
      noMoreGroupItems: false,
      itemsLoading: false,
      scrollListenerExists: true,
    };
  }

  async componentWillMount() {
    // await this.context.global.getUserByUuid()
    if (this.context.global.data.attributes) {
      this.context.global.getAttributes();
    }

    try {
      // if (this.context.global.data.shoppingCart === null) {
      const shoppingCart = await this.context.global.getCurrentShoppingCart();
      await this.context.global.checkShoppingTimeLeft();
      // if (this.context.global.data.groupCategories === null && shoppingCart) {
      await this.context.global.getGroupCategories(
        shoppingCart.popUpLocationInstance.uuid
      );
      await this.context.global.getMoreGroupCategories(
        shoppingCart.popUpLocationInstance.uuid
      );
      await this.context.global.getMoreGroupCategories(
        shoppingCart.popUpLocationInstance.uuid
      );
      await this.context.global.getMoreGroupCategories(
        shoppingCart.popUpLocationInstance.uuid
      );
      // }
      this.context.global.getUserFavorites();
      this.context.global.getUserReorderItems();
      // }
    } catch (err) {}
    if (
      this.context.global.data.groupCategories === null &&
      this.context.global.data.shoppingCart
    ) {
      await this.context.global.getGroupCategories(
        this.context.global.data.shoppingCart.popUpLocationInstance.uuid
      );
    } else {
    }

    window.onpopstate = this.onBackOrForwardButtonEvent;
  }

  isBottom(el) {
    if (el) {
      return el.getBoundingClientRect().bottom <= window.innerHeight + 100;
    }
  }

  componentDidMount() {
    window.scrollTo(
      0,
      this.context.global.data.dashboardpageYOffset
        ? this.context.global.data.dashboardpageYOffset
        : 0
    );
    document.addEventListener("scroll", this.trackScrolling);
  }

  onBackOrForwardButtonEvent = (e) => {
    e.preventDefault();
    this.context.global.handleDashboardBackButtonClick();
  };

  componentWillUnmount() {
    window.onpopstate = () => {};
    document.removeEventListener("scroll", this.trackScrolling);
    this.context.global.submitShoppingCartChanges();
  }

  trackScrolling = async () => {
    const {
      searchBarTextValue,
      searchResults,
      appMenuDialogState,
      accountDialogState,
      favoritesDialogState,
      itemViewDialogState,
      ordersDialogState,
      shoppingCartDialogState,
      chooseSavingsDialogState,
    } = this.context.global.data;
    const wrappedElement = document.getElementById("groupListings");
    if (this.isBottom(wrappedElement)) {
      this.setState({ itemsLoading: true });

      let items;
      if (searchBarTextValue.length > 0 && searchResults.length > 0) {
        items = await this.context.global.getMoreSearchResults();
      } else {
        items = await this.context.global.getMoreGroupCategories(
          this.context.global.data.shoppingCart.popUpLocationInstance.uuid
        );
      }

      this.setState({ itemsLoading: false });

      if (items && items.length === 0 && searchBarTextValue.length === 0) {
        document.removeEventListener("scroll", this.trackScrolling);

        this.setState({
          noMoreGroupItems: true,
          itemsLoading: false,
          scrollListenerExists: false,
        });
      }
    }

    if (
      this.context.global.data.searchResultPromiseCount === 0 &&
      !searchBarTextValue &&
      !searchResults &&
      !appMenuDialogState &&
      !accountDialogState &&
      !favoritesDialogState &&
      !itemViewDialogState &&
      !ordersDialogState &&
      !shoppingCartDialogState &&
      !chooseSavingsDialogState
    ) {
      this.context.global.setGlobalState(
        "dashboardpageYOffset",
        window.pageYOffset
      );
      this.context.global.setGlobalState("scrollPositionSet", true);
    } else {
      this.context.global.setGlobalState("scrollPositionSet", false);
    }
  };

  render() {
    const { theme } = this.props;
    let {
      groupCategories,
      searchResults,
      // covidDialog,
    } = this.context.global.data;
    const {
      searchBarTextValue,
      groupItemsLoading,
      dashboardpageYOffset,
      searchResultPromiseCount,
      scrollPositionSet,
      searchItemsLoading,
      appMenuDialogState,
      accountDialogState,
      favoritesDialogState,
      itemViewDialogState,
      ordersDialogState,
      shoppingCartDialogState,
      chooseSavingsDialogState,
    } = this.context.global.data;

    if (
      !searchBarTextValue &&
      !searchResults &&
      !scrollPositionSet &&
      !appMenuDialogState &&
      !accountDialogState &&
      !favoritesDialogState &&
      !itemViewDialogState &&
      !ordersDialogState &&
      !shoppingCartDialogState &&
      !chooseSavingsDialogState
    ) {
      window.scrollTo(0, dashboardpageYOffset);
    }

    if (groupCategories) {
      groupCategories = groupCategories.filter(
        (group) => group.itemCategoryList.length > 0
      );
    }
    if (searchResults) {
      searchResults = searchResults.filter(
        (group) => group.itemCategoryList.length > 0
      );
    }

    return (
      <FFAppBar history={this.props.history}>
        <div style={{ height: 60 }} />
        <Banner />
        {!groupCategories ? (
          <div
            style={{
              height: 100,
              textAlign: "center",
              padding: "2rem 0 2rem 0",
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <>
            <div id="groupListings">
              {searchResultPromiseCount > 0 ? (
                <div style={{ width: "100%" }}>
                  <LinearProgress />
                </div>
              ) : null}
              {searchResults && searchBarTextValue.length >= 2
                ? this.renderGroups(searchResults, theme, "SEARCH")
                : this.renderGroups(groupCategories, theme, "GROUP")}

              <div
                style={{ height: 20, marginBottom: 20, textAlign: "center" }}
              >
                {" "}
                {groupItemsLoading || searchItemsLoading ? (
                  <CircularProgress />
                ) : null}
              </div>
            </div>
            <div style={{ height: 60 }} />
            <ItemView />
            <OldShoppingCartDialog />
            <Dialog
              open={false}
              onClose={() =>
                this.context.global.setGlobalState("covidDialog", false)
              }
              style={{ zIndex: 95000 }}
            >
              <div className={s.covidMessage}>
                <span>
                  <span className={s.covidMessageHeader}>
                    We appreciate your patience!
                  </span>
                  <br />
                  <br />
                  Due to increased demand, you may experience longer wait times,
                  limited inventory, customer service delays, and limited time
                  slots with this service. The items shown may not accurately
                  reflect what is in stock. We are working around the clock to
                  meet the needs of our community. Thank you for your support!
                  <br />
                  <br />
                  <Button
                    onClick={() =>
                      this.context.global.setGlobalState("covidDialog", false)
                    }
                    variant={"outlined"}
                    style={{ width: "100%" }}
                  >
                    Close
                  </Button>
                </span>
              </div>
            </Dialog>
          </>
        )}
      </FFAppBar>
    );
  }

  renderGroups(groupCategoriesList, theme, key) {
    if (groupCategoriesList.length === 0) {
      return <div className={s.noResults}>No results</div>;
    }

    const moneyFormatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    let g = groupCategoriesList.map((group) => {
      return (
        <div className={s.groupRow} key={group.enum}>
          <div className={s.groupTitle}>{group.name}</div>
          <div className={s.itemRowContainer}>
            {group.itemCategoryList.map((itemCategory) => {
              return (
                <button
                  type="button"
                  key={itemCategory.uuid}
                  className={s.itemCard}
                  // style={itemCategory.numberOfOptions ? null : { backgroundColor: 'red' }}
                  onClick={() => {
                    this.context.global.setGlobalState(
                      "selectedItemViewCategory",
                      null
                    );
                    this.context.global.getItemsInCategory(itemCategory.uuid);
                    // this.context.global.setGlobalState('itemViewDialogState', true)
                    this.context.global.handleDashboardActions(
                      "FORWARD",
                      "itemViewDialogState"
                    );
                  }}
                >
                  {itemCategory.isFeatured ? (
                    <div
                      style={{
                        marginLeft: 0,
                        marginTop: 5,
                        width: 100,
                        height: 25,
                        background: "#7EB955",
                        borderRadius: "0 5px 5px 0",
                        fontVariant: "small-caps",
                        fontSize: 12,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        boxShadow: "1px 1px 1px 1px #ccc",
                        color: "white",
                      }}
                    >
                      <div style={{ marginRight: 5 }}>
                        <img src={asmLogo} width={20} height={20} alt={""} />
                      </div>
                      FEATURED
                    </div>
                  ) : null}
                  <div className={s.itemImageContainer}>
                    <LazyLoad offsetVertical={0}>
                      <img src={getImageUrl(itemCategory.imageUrl)} alt={""} />
                    </LazyLoad>
                  </div>
                  <div className={s.cardContent}>
                    <div className={s.cardPrice}>
                      {itemCategory.numberOfOptions > 3
                        ? itemCategory.numberOfOptions + " items"
                        : itemCategory.price == null
                        ? "Price not available"
                        : moneyFormatter.format(itemCategory.price / 100)}
                    </div>
                    <div className={s.cardCategoryName}>
                      {itemCategory.name}
                      {/* {itemCategory.name.length > 24 ? "..." : null} */}
                    </div>
                    {/* TODO - don't render for now, since it doesn't work well with bottom buttons */}
                    {/* {itemCategory.numberOfOptions == null ||
                    itemCategory.numberOfOptions <= 1 ? null : (
                      <div className={s.cardOptionsCountContainer}>
                        <span className={s.cardOptionsCount}>
                          {itemCategory.numberOfOptions}
                        </span>
                        <span> options</span>
                      </div>
                    )} */}
                  </div>
                  <div className={s.itemBottomRow}>
                    <div
                      className={s.itemBottomRowLeft}
                      style={{
                        color: theme.palette.primary.main,
                      }}
                    >
                      {itemCategory.favorited ? (
                        <Favorite fontSize={"small"} />
                      ) : (
                        ""
                      )}
                    </div>
                    <div className={s.itemBottomRowMiddle} />
                    <div
                      className={s.itemBottomRowRight}
                      style={{
                        color: theme.palette.primary.main,
                      }}
                    >
                      {itemCategory.inCart ? (
                        <ShoppingCart fontSize={"small"} />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      );
    });

    return <div key={key}>{g}</div>;
  }
}

export default withTheme()(Dashboard);

function Banner() {
  const { global: g } = React.useContext(globalContext);
  const shoppingCart = g.data?.shoppingCart;
  const fulfillmentType = shoppingCart?.popUpLocationInstance?.fulfillmentType;

  if (shoppingCart == null || fulfillmentType == null) {
    return null;
  }

  function renderChildren() {
    if (fulfillmentType === "DELIVERY") {
      const deliveryLocation = shoppingCart.deliveryLocation;
      const popupLocationInstance = shoppingCart.popUpLocationInstance;
      return (
        <Link to="/find-hot-spot" className={s.bannerLink}>
          <div className={s.bannerLayout}>
            <span className={s.bannerTextEmphasis}>Delivery</span>
            {deliveryLocation == null ? null : <span> to </span>}
            {deliveryLocation == null ? null : (
              <span className={s.bannerTextEmphasis + " " + s.bannerAddress}>
                {deliveryLocation.address1}
              </span>
            )}
            <span> on </span>
            <span className={s.bannerTextEmphasis}>
              {moment(popupLocationInstance.pickupTimestampStart * 1000).format(
                "dddd, h:mma"
              )}
            </span>
            <span> - </span>
            <span className={s.bannerTextEmphasis}>
              {moment(popupLocationInstance.pickupTimestampEnd * 1000).format(
                "h:mma"
              )}
            </span>
          </div>
        </Link>
      );
    } else {
      const popupLocationInstance = shoppingCart.popUpLocationInstance;
      const popUpLocation = popupLocationInstance.popUpLocation;
      return (
        <Link to="/find-hot-spot" className={s.bannerLink}>
          <div className={s.bannerLayout}>
            <span className={s.bannerTextEmphasis}>Pickup</span>
            {popUpLocation == null ? null : <span> at </span>}
            {popUpLocation == null ? null : (
              <span className={s.bannerTextEmphasis + " " + s.bannerAddress}>
                {popUpLocation.address1}
              </span>
            )}
            <span> on </span>
            <span className={s.bannerTextEmphasis}>
              {moment(popupLocationInstance.pickupTimestampStart * 1000).format(
                "dddd, h:mma"
              )}
            </span>
            <span> - </span>
            <span className={s.bannerTextEmphasis}>
              {moment(popupLocationInstance.pickupTimestampEnd * 1000).format(
                "h:mma"
              )}
            </span>
          </div>
        </Link>
      );
    }
  }

  return <header className={s.banner}>{renderChildren()}</header>;
}
